import withStore from 'store/StoreContainer';

import { goToEditDraft, goToEditDraftContent, goToEditDraftCover } from 'modules/v2/editor/store';

import {
  addressesSelector,
  addUserAddresses,
  clearPublish,
  countriesSelector,
  creditsSelector,
  deleteUserAddresses,
  editUserAddresses,
  getPublish,
  orderSelector,
  preflightSelector,
  statesSelector,
  submitOrder,
  submitReorder,
} from 'modules/v2/publish/store';

const mapStateToProps = (state) => ({
  addresses: addressesSelector(state),
  credits: creditsSelector(state),
  preflight: preflightSelector(state),
  countries: countriesSelector(state),
  states: statesSelector(state),
  order: orderSelector(state),
});

const mapDispatchToProps = {
  addUserAddresses,
  editUserAddresses,
  clearPublish,
  deleteUserAddresses,
  getPublish,
  goToEditDraft,
  goToEditDraftCover,
  goToEditDraftContent,
  submitOrder,
  submitReorder,
};

export default withStore(mapStateToProps, mapDispatchToProps);
